/* eslint-disable */
import React from "react";
// nodejs library to set properties for components
import PropTypes from "prop-types";
// react components for routing our app without refresh
import { Link } from "react-router-dom";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import Icon from "@material-ui/core/Icon";

// @material-ui/icons
import Apps from "@material-ui/icons/Apps";
import ShoppingCart from "@material-ui/icons/ShoppingCart";
import ViewDay from "@material-ui/icons/ViewDay";
import Dns from "@material-ui/icons/Dns";
import Build from "@material-ui/icons/Build";
import ListIcon from "@material-ui/icons/List";
import People from "@material-ui/icons/People";
import Assignment from "@material-ui/icons/Assignment";
import MonetizationOn from "@material-ui/icons/MonetizationOn";
import Chat from "@material-ui/icons/Chat";
import Call from "@material-ui/icons/Call";
import ViewCarousel from "@material-ui/icons/ViewCarousel";
import AccountBalance from "@material-ui/icons/AccountBalance";
import ArtTrack from "@material-ui/icons/ArtTrack";
import ViewQuilt from "@material-ui/icons/ViewQuilt";
import LocationOn from "@material-ui/icons/LocationOn";
import Fingerprint from "@material-ui/icons/Fingerprint";
import AttachMoney from "@material-ui/icons/AttachMoney";
import Store from "@material-ui/icons/Store";
import AccountCircle from "@material-ui/icons/AccountCircle";
import PersonAdd from "@material-ui/icons/PersonAdd";
import Layers from "@material-ui/icons/Layers";
import ShoppingBasket from "@material-ui/icons/ShoppingBasket";
import LineStyle from "@material-ui/icons/LineStyle";

// core components
import CustomDropdown from "components/CustomDropdown/CustomDropdown.jsx";
import Button from "components/CustomButtons/Button.jsx";

import headerLinksStyle from "assets/jss/material-kit-pro-react/components/headerLinksStyle.jsx";
import { baseOeaAppUrl } from '../../assets/const.js';
import ApiClient from '../../services/api-client/ApiClient';
import TranslationService from '../../services/translation/TransationService';

import {
  catalanPublicWebUrl,
  spanishPublicWebUrl,
  englishPublicWebUrl,
} from 'assets/const';

function HeaderLinks({ ...props }) {
  const easeInOutQuad = (t, b, c, d) => {
    t /= d / 2;
    if (t < 1) return c / 2 * t * t + b;
    t--;
    return -c / 2 * (t * (t - 2) - 1) + b;
  };

  const smoothScroll = (e, target) => {
    if (window.location.pathname === "/sections") {
      var isMobile = navigator.userAgent.match(
        /(iPad)|(iPhone)|(iPod)|(android)|(webOS)/i
      );
      if (isMobile) {
        // if we are on mobile device the scroll into view will be managed by the browser
      } else {
        e.preventDefault();
        var targetScroll = document.getElementById(target);
        scrollGo(document.documentElement, targetScroll.offsetTop, 1250);
      }
    }
  };
  const scrollGo = (element, to, duration) => {
    var start = element.scrollTop,
      change = to - start,
      currentTime = 0,
      increment = 20;

    var animateScroll = function() {
      currentTime += increment;
      var val = easeInOutQuad(currentTime, start, change, duration);
      element.scrollTop = val;
      if (currentTime < duration) {
        setTimeout(animateScroll, increment);
      }
    };
    animateScroll();
  };
  var onClickSections = {};

  const { classes, dropdownHoverColor } = props;
  return (
    <List className={classes.list + " " + classes.mlAuto}>
      <ListItem className={classes.listItem}>
        <a href="/#facilities">
          <Button
            color="transparent"
            className={
              classes.navLink + " " + classes.navButton
            }
          >
            { TranslationService.get('HEADER.MENU.SEARCH') }
          </Button>
        </a>
      </ListItem>
      <ListItem className={classes.listItem}>
        <a href="/#about-us">
          <Button
            color="transparent"
            className={
              classes.navLink + " " + classes.navButton
            }
          >
            { TranslationService.get('HEADER.MENU.ABOUT_US') }
          </Button>
        </a>
      </ListItem>
      <ListItem className={classes.listItem}>
        <a href="/#opinion">
          <Button
            color="transparent"
            className={
              classes.navLink + " " + classes.navButton
            }
          >
            { TranslationService.get('HEADER.MENU.OPINION') }
          </Button>
        </a>
      </ListItem>
      <ListItem className={classes.listItem}>
        <a onClick={()=>{downloadManual()}}>
          <Button
            color="transparent"
            className={
              classes.navLink + " " + classes.navButton
            }
          >
            { TranslationService.get('HEADER.MENU.MANUAL') }
          </Button>
        </a>
      </ListItem>
      <ListItem>
        <a href={baseOeaAppUrl}>
          <Button
            color="transparent"
            className={
              classes.navLink + " " + classes.navButton
            }
          >
            { TranslationService.get('HEADER.MENU.SIGN_IN') }
          </Button>
        </a>
      </ListItem>
      <ListItem className={classes.listItem}>
        <CustomDropdown
          noLiPadding
          navDropdown
          hoverColor={dropdownHoverColor}
          buttonProps={{
            className: classes.navLink,
            color: "transparent",
          }}
          buttonIcon={getLanguageIcon}
          dropdownList={[
            <a href={spanishPublicWebUrl} className={classes.dropdownLink}>
              ES
            </a>,
            <a href={catalanPublicWebUrl} className={classes.dropdownLink}>
              CA
            </a>,
            <a href={englishPublicWebUrl} className={classes.dropdownLink}>
              EN
            </a>,
          ]}
        />
      </ListItem>
    </List>
  );
}

function downloadManual() {
  ApiClient.download.get('ManualUsuario')
    .then((res) => {
      const contentType = "application/pdf";
      var blob = getBlob(res.data.blob, contentType);
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = 'manual.pdf';
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
    });
}

function getBlob(b64Data, contentType) {
  var sliceSize = 512;
  b64Data = b64Data.replace(/^[^,]+,/, '');
  b64Data = b64Data.replace(/\s/g, '');
  var byteCharacters = window.atob(b64Data);
  var byteArrays = [];

  for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    var slice = byteCharacters.slice(offset, offset + sliceSize);

    var byteNumbers = new Array(slice.length);
    for (var i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    var byteArray = new Uint8Array(byteNumbers);

    byteArrays.push(byteArray);
  }

  return new Blob(byteArrays, {type: contentType});
}

function getLanguageIcon() {
  const domain = document.location.origin;
  let icon = Apps;
  switch (domain) {
    case catalanPublicWebUrl:
      icon = (<span>CA</span>);
      break;
    case englishPublicWebUrl:
      icon = (<span>EN</span>);
      break;
    default:
      icon = (<span>ES</span>);
  }
  return icon;
};

HeaderLinks.defaultProps = {
  hoverColor: "primary"
};

HeaderLinks.propTypes = {
  dropdownHoverColor: PropTypes.oneOf([
    "dark",
    "primary",
    "info",
    "success",
    "warning",
    "danger",
    "rose"
  ])
};

export default withStyles(headerLinksStyle)(HeaderLinks);



// WEBPACK FOOTER //
// ./src/components/Header/HeaderLinks.jsx